import { gql } from "@apollo/client";

export const REMOVE_VENUE_MANAGER = gql`
  mutation removeVenueManager($venueManagerUserId: Int!) {
    removeVenueManager(venueManagerUserId: $venueManagerUserId) {
      id
    }
  }
`;
